import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        padding: '0px 16px',
        height: '100%',
    },
    containerBg: {
        backgroundColor: '#1A1A1A',
    },
    pl20: {
        paddingLeft: '20px',
    },
    imgContainer: {
        height: 48,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
        textAlign: 'center',
    },
    welcomeContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    welcomeTitle: {
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '16px',
        marginTop: '32px',
    },
    textColorIntro: {
        color: '#1A1A1A',
    },
    textColorComplete: {
        color: '#FFFFFF',
    },
    stylingContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: '52px',
    },
    stylingText: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontWeight: 400,
        fontSize: '18px',
        color: '#1A1A1A',
        lineHeight: '23px',
    },
    stylingImg: {
        marginTop: '12px',
    },
    listContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '14px',
        marginTop: '40px',
        lineHeight: '21px',
    },
    list: {
        marginTop: '10px',
        textAlign: 'left',
    },
    button: {
        width: '100%',
        borderRadius: '30px',
        padding: '12px',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '14px',
        marginBottom: '26px',
    },
    introButtonColors: {
        color: '#ffffff',
        background: '#000000',
    },
    completeButtonColors: {
        color: '#1A1A1A',
        background: '#F2F2F2',
    },
}));
